import { Reducer } from "redux";
import { HomeTopAction } from "modules/homeTop/actions";
import { BinderItem } from "models/BinderItem";
import { HomeTrendReportApiResponse } from "../../features/HomeTopPage/api/home_home-trend-report/HomeTrendReportApiResponse";
import { HomeSectorReportApiResponse } from "../../features/HomeTopPage/api/home_home-sector-report/HomeSectorReportApiResponse";
import { HomeStrategyApiResponse } from "../../features/HomeTopPage/api/home_strategy/HomeStrategyApiResponse";
import { HomeQuickAccessApiResponse } from "../../features/HomeTopPage/api/home_quick-access/HomeQuickAccessApiResponse";
import { UserQuickAccessApiResponse } from "features/HomeTopPage/api/home_quick-access/UserQuickAccessApiResponse";

export interface HomeTopState {
  myBinders?: BinderItem[];
  nikkeiBinders?: BinderItem[];
  nikkeiBizTrends?: HomeTrendReportApiResponse;
  sectorReports?: HomeSectorReportApiResponse;
  sectorAuth?: boolean;
  corporationStrategies?: HomeStrategyApiResponse;
  homeQuickAccess?: HomeQuickAccessApiResponse;
  userQuickAccess?: UserQuickAccessApiResponse;
}

const initialState: HomeTopState = {};

export const homeTop: Reducer<HomeTopState, HomeTopAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case "homeTop/SET_HOME_QUICK_ACCESS":
      return { ...state, homeQuickAccess: action.payload.homeQuickAccess };
    case "homeTop/SET_USER_QUICK_ACCESS":
      return { ...state, userQuickAccess: action.payload.userQuickAccess };
    case "homeTop/SET_MY_BINDERS":
      return { ...state, myBinders: action.payload.myBinders };
    case "homeTop/SET_NIKKEI_BINDERS":
      return { ...state, nikkeiBinders: action.payload.nikkeiBinders };
    case "homeTop/SET_NIKKEI_BIZ_TRENDS":
      return { ...state, nikkeiBizTrends: action.payload.nikkeiBizTrends };
    case "homeTop/SET_SECTOR_REPORTS":
      return { ...state, sectorReports: action.payload.sectorReports };
    case "homeTop/SET_SECTOR_AUTHORITY":
      return { ...state, sectorAuth: action.payload.auth };
    case "homeTop/SET_CORPORATION_STRATEGIES":
      return {
        ...state,
        corporationStrategies: action.payload.corporationStrategies
      };
    default:
      return state;
  }
};
